<script>
  import formatDateTime from "common/utils/formatDateTime";
  import Image from "./Image.svelte";
  import { getContext } from "svelte";

  export let width;
  export let height;
  export let src;
  export let href = "#";
  export let pathBack;
  export let title;
  export let duration;
  export let type = "VOD";
  export let start_at;
  export let available_till;
  export let end_at;
  export let is_expired;
  export let is_canceled;
  export let is_live;
  export let is_published = true;

  const format = formatDateTime("YYYY-MM-DD HH:mm:SS");
  const t = getContext("STRINGS");

  let videoLabel;
  let heroLabel;
  let subtitle;

  $: href = is_expired ? "#" : `${href}?path_back=${pathBack}`;
  $: live = is_live && type === "PPV";
  $: pending =
    (!is_live && type === "PPV") || (!is_published && type === "VOD");
  $: inactive = is_expired || is_canceled;

  $: if (is_canceled) {
    heroLabel = t("canceled");
  } else if (is_expired) {
    if (type === "VOD") {
      heroLabel = t("expired");
      subtitle = `${t("expired_at")} ${available_till}`;
    } else {
      heroLabel = t("ended");
      subtitle = `${t("ended_at")} ${end_at}`;
    }
  } else if (live) {
    videoLabel = t("live_now");
    subtitle = `${t("end_at")} ${end_at}`;
  } else if (pending) {
    if (type === "PPV") {
      videoLabel = t("live");
      subtitle = `${t("start_at")} ${start_at}`;
    } else {
      subtitle = `${t("start_at")} ${start_at}`;
    }
  } else {
    if (type === "VOD") {
      videoLabel = duration;
    } else {
      videoLabel = t("live");
      subtitle = `${t("start_at")} ${start_at}`;
    }
  }
</script>

<style>
  .slide {
    margin: 0;
    padding: 0;
    flex: 0 0 274px;
    margin-right: var(--slides-gap);
    list-style: none;
  }

  a,
  a:hover {
    color: #333;
    color: var(--tv-foreground-color, #fff);
    cursor: pointer;
  }

  .image-wrapper {
    position: relative;
  }

  .video-label {
    position: absolute;
    right: 8px;
    bottom: 8px;
    padding: 0.2rem 0.3rem;
    font-size: 0.9rem;
    font-weight: 500;
    color: #fff;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 3px;
    user-select: none;
    letter-spacing: 0.8px;
  }

  .hero-label {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    transform: translate(-50%, -50%);
    color: #fff;
    line-height: 1;
    font-weight: 700;
    font-size: 1.75rem;
    overflow: hidden;
    box-sizing: border-box;
    text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.5);
  }

  .video-label.live {
    background: rgba(235, 0, 0, 0.95);
  }

  .footer {
    margin-top: 0.75rem;
    margin-bottom: 0.5rem;
    padding: 0.1rem;
    box-sizing: border-box;
  }

  .title {
    font-size: 1rem;
    font-weight: 500;
    display: -webkit-box;
    max-height: calc(3.2rem);
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 2;
  }

  .subtitle {
    margin-top: 0.5rem;
    font-size: 1rem;
    font-weight: 400;
  }
</style>

<div class="slide">
  <a {href} on:focus data-no-turbolink>
    <div class="image-wrapper">
      <Image {width} {height} {src} muted={inactive} {pending} />
      {#if videoLabel}
        <div class="video-label" class:live>{videoLabel}</div>
      {/if}
      {#if heroLabel}
        <div class="hero-label">{heroLabel}</div>
      {/if}
    </div>
    <div class="footer">
      {#if title}
        <div class="title" {title}>{title}</div>
      {/if}
      {#if subtitle}
        <div class="subtitle">{subtitle}</div>
      {/if}
    </div>
  </a>
</div>
